
import addressMixin from '@/mixins/addressMixin.js';
import cartMixin from '@/mixins/cartMixin.js';
import carriersMixin from '@/mixins/carriersMixin.js';
import { CollapseTransition } from 'element-ui';
export default {
  mixins: [addressMixin, cartMixin, carriersMixin],
  name: 'CheckoutAddressDelivery',
  computed: {
    shippingAddress() {
      return this.$store.state.checkout.shippingAddress;
    },
    checkoutError() {
      return this.$store.state.checkout.checkoutError;
    },
  },
  data() {
    return {
      showForm: false,
      isAddingAddress: false,
      changeAddress: false,
      updating: false,
      lastAddressStr: '',
    };
  },
  methods: {
    toggleForm() {
      this.showForm = !this.showForm;
      if (this.showForm) this.isAddingAddress = true;
    },
    async removeCarrier(address) {
      try {
        const countryIsoCode =
          address?.CountryIsoCode ||
          address?.Country?.IsoCode ||
          this.$localisation.appCountryIsoCode;
        if (countryIsoCode) {
          this.$store.commit('shop/localisation/setAppCountryIsoCode', {
            $auth: this.$auth,
            val: countryIsoCode,
          });
        }
        await this.cartService.setCarrierToCart({
          idCarrier: 'null',
          idRelayPoint: 'null',
          countryIsoCode: countryIsoCode,
          idAddress: address?.IdAddress,
        });
        await this.$store.dispatch('cart/fetchCart', {
          countryIsoCode: countryIsoCode,
        });
      } catch (e) {
        console.error('Failed to reset carrier', e);
      }
    },
    selectAddress(address) {
      this.updating = true;
      this.addressService
        .updateAddressType({
          idAddress: address.IdAddress,
          isInvoice: address.IsInvoice,
          isDelivery: true,
        })
        .then(() => {
          this.addressService.fetchAddresses();
          this.changeAddress = false;
        })
        .finally(() => {
          this.updating = false;
        });
    },
    onAddressFilled(address) {
      if (this.addresses?.length > 0) return;
      if (!address || (!address.Address1 && !address.Postcode)) return;

      if (this.addressFilledTimeout) clearTimeout(this.addressFilledTimeout);
      this.addressFilledTimeout = setTimeout(() => {
        const data = { ...address };
        const oldAddressObj = this.$store.state.checkout.shippingAddress || {};
        const oldAddressStr = JSON.stringify(
          this.$store.state.checkout.shippingAddress
        );

        this.$store.commit('checkout/setShippingAddress', { data });
        if (this.$store.state.checkout.sameAsDelivery) {
          this.$store.commit('checkout/setInvoiceAddress', { data });
        }

        const hasAffectingChanges =
          oldAddressObj.Address1 !== data.Address1 ||
          oldAddressObj.City !== data.City ||
          oldAddressObj.Postcode !== data.Postcode ||
          oldAddressObj.CountryIsoCode !== data.CountryIsoCode ||
          oldAddressObj?.Country?.IsoCode !== data?.Country?.IsoCode;

        if (oldAddressStr && hasAffectingChanges) {
          this.removeCarrier(data);
        } else if (!oldAddressStr && data.CountryIsoCode) {
          // First time adding an address
          this.removeCarrier(data);
        }
      }, 500);
    },
  },

  watch: {
    getAddressDelivery: {
      handler(val) {
        if (!val) return;
        this.$store.commit('checkout/setShippingAddress', { data: val });

        const currentStr = JSON.stringify(val);
        const newCountry = val?.CountryIsoCode || val?.Country?.IsoCode;

        if (this.lastAddressStr && this.lastAddressStr !== currentStr) {
          const lastObj = JSON.parse(this.lastAddressStr);
          const currentObj = JSON.parse(currentStr);

          const hasAffectingChanges =
            lastObj.Address1 !== currentObj.Address1 ||
            lastObj.City !== currentObj.City ||
            lastObj.Postcode !== currentObj.Postcode ||
            lastObj.CountryIsoCode !== currentObj.CountryIsoCode ||
            lastObj?.Country?.IsoCode !== currentObj?.Country?.IsoCode;

          if (hasAffectingChanges) {
            // Address changed properties (or new address selected)
            this.removeCarrier(val);
          }
        }
        // else if (!this.lastAddressStr) {

        //   // Initial load: Only refresh if Country changed from what's already in the cart
        //   if (newCountry && newCountry !== this.cart?.Country?.IsoCode) {

        //     this.removeCarrier(val);
        //   }
        // }
        this.lastAddressStr = currentStr;
      },
      deep: true,
      immediate: true,
    },
    checkoutError: {
      handler(val) {
        if (val && !this.showForm && this.shippingAddress) {
          const requiredFields = [
            'Firstname',
            'Lastname',
            'Address1',
            'Postcode',
            'City',
            'CountryIsoCode',
            'MobilePhone',
          ];
          const isMissing = requiredFields.some(
            (f) =>
              !this.shippingAddress[f] ||
              !this.shippingAddress[f].toString().trim()
          );
          if (isMissing) {
            this.showForm = true;
            this.isAddingAddress = false;
          }
        }
      },
    },
  },
  components: {
    CollapseTransition,
  },
};
